export default (message, extraClass = false) => {
  const alertBox = document.querySelector("#lite-alert");
  if (alertBox) {
    alertBox.textContent = message;
    if (extraClass) {
      alertBox.classList.add(extraClass);
    }
    alertBox.style.display = "block";
    void alertBox.offsetWidth;
    alertBox.style.opacity = 1;
    setTimeout(() => {
      alertBox.style.opacity = 0;
      setTimeout(() => {
        alertBox.style.display = "none";
      }, 500);
    }
    , 6000);
  } else {
    console.log("Alert box not found")
  }
}